import PropTypes from "prop-types";
import { FormProvider, useForm } from "react-hook-form";

import SearchInput from "../../components/Form/SearchInput";

import "./searchProposals.scss";

const SearchProposals = ({ name, label, setSearchKeyword, options }) => {
  const methods = useForm({
    mode: "onTouched",
  });

  const searchProps = {
    name,
    label,
    setSearchKeyword,
    options,
  };

  return (
    <div className="search-proposals">
      <div className="search-proposals__container">
        <FormProvider {...methods}>
          <SearchInput {...searchProps} />
        </FormProvider>
      </div>
    </div>
  );
};

SearchProposals.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  setSearchKeyword: PropTypes.func,
  options: PropTypes.object,
};

SearchProposals.defaultProps = {
  name: "search",
  label: "Search proposals, advisors, strategies, and reports",
  options: {},
};

export default SearchProposals;
